import React from 'react';
import { Select, MenuItem, Checkbox, ListItemText } from '@material-ui/core';

const SpecialSelect = ({ values = [], onChange, name, children, selectedValues, ...rest }) => {
    const handleRadioChange = (event) => {
        if (onChange) {
            const value = event.target.value;
            onChange({ target: { value, name } });
        }
    };
    const value = selectedValues ? selectedValues : rest.value;

    return (
        <div>
            <Select
                onChange={handleRadioChange}
                {...rest}
                value={value}
            >
                {values.length === 0 ? (
                    children// Afficher les enfants si la longueur des valeurs est égale à zéro
                ) : (
                    // Sinon, traiter les valeurs selon leur type
                    values.map((val, index) => {
                        // Vérifier si la valeur est un objet avec les propriétés 'value' et 'name'
                        if (typeof val === 'object' && val.value !== undefined && val.name !== undefined) {
                            let profilesString = '';
                            const person = rest.value;
                            if (Array.isArray(rest.doublon) && rest.doublon.length > 0) {
                                // Recherchez la valeur val.value dans l'index
                                rest.doublon.forEach((profile, i) => {
                                    if (profile.includes(val.value)) {
                                        // Ajouter à profilesString si la valeur est trouvée
                                        profilesString += `(profil ${i + 1}) `;
                                    }
                                });
                            }
                            return (
                                <MenuItem value={val} key={val.value}>
                                    <Checkbox color='primary' key={val.value} checked={person.map(item => item.value).indexOf(val.value) > -1} />
                                    <ListItemText primary={val.name} secondary={profilesString} />
                                </MenuItem>
                            );
                            // }
                        } else {
                            return (
                                // Si la valeur n'est pas un objet, afficher la valeur elle-même
                                <MenuItem value={val} key={index}>{`${val === '' ? 'Non renseigné' : val} (profil ${index + 1})`}</MenuItem>
                            );
                        }
                    })
                )}
            </Select>

        </div>
    );
};

export default SpecialSelect;

// import React from 'react';
// import { Select, MenuItem, Checkbox, ListItemText } from '@material-ui/core';

// const SpecialSelect = ({ values = [], onChange, name, children, ...rest }) => {
//     // const handleRadioChange = (event) => {
//     //     const value = event.target.value;
//     //     if (onChange) {
//     //         onChange({ target: { value, name, id:value } });
//     //     }
//     // };
//     const handleRadioChange = (event) => {
//         const value = event.target.value;
//         if (onChange) {
//             onChange({ target: { value: Array.isArray(value) ? value : [value], name, id: value.map(item => item.value) } });
//         }
//     };

//     console.log('values ==============>>>>>>>>>> ', values, rest.label, rest.doublon);
//     return (
//         <div>
//             <Select
//                 onChange={handleRadioChange}
//                 {...rest}
//                 value={rest.value}
//             >
//                 {values.length === 0 ? (
//                     children // Afficher les enfants si la longueur des valeurs est égale à zéro
//                 ) : (
//                     // Sinon, traiter les valeurs selon leur type
//                     values.map((val, index) => {
//                         // Vérifier si la valeur est un objet avec les propriétés 'value' et 'name'
//                         if (typeof val === 'object' && val.value !== undefined && val.name !== undefined) {
//                             let profilesString = '';
//                             let person = rest.value; // Utilisez un accesseur dynamique pour rest.value
//                             if (rest.itemAccessor && rest.itemAccessor !== 'value') {
//                                 person = rest[rest.itemAccessor];
//                             }
//                             let valAccessor = 'value';
//                             if (rest.valAccessor && rest.valAccessor !== 'value') {
//                                 valAccessor = rest.valAccessor;
//                             }
//                             let itemAccessor = 'value';
//                             if (rest.valAccessor && rest.valAccessor !== 'value') {
//                                 itemAccessor = rest.valAccessor;
//                             }
//                             if (Array.isArray(rest.doublon) && rest.doublon.length > 0) {
//                                 // Recherchez la valeur val.value dans l'index
//                                 rest.doublon.forEach((profile, i) => {
//                                     if (profile.includes(val[valAccessor])) { // Utilisez un accesseur dynamique pour val.value
//                                         // Ajouter à profilesString si la valeur est trouvée
//                                         profilesString += `(profil ${i + 1}) `;
//                                     }
//                                 });
//                             }
//                             console.log('personnes ==============>>>>>>>', person, itemAccessor, valAccessor, name, rest[rest.itemAccessor]);
//                             return (
//                                 <MenuItem value={val} key={val.value}>
//                                     <Checkbox color='primary' key={val[valAccessor]} checked={person.map(item => item[itemAccessor]).indexOf(val[valAccessor]) > -1} />
//                                     <ListItemText primary={val.name} secondary={profilesString} />
//                                 </MenuItem>
//                             );
//                         } else {
//                             return (
//                                 // Si la valeur n'est pas un objet, afficher la valeur elle-même
//                                 <MenuItem value={val} key={index}>{`${val === '' ? 'Non renseigné' : val} (profil ${index + 1})`}</MenuItem>
//                             );
//                         }
//                     })
//                 )}
//             </Select>

//         </div>
//     );
// };

// export default SpecialSelect;

